import React, { createContext, useContext, useState } from 'react';
import LeadFormModal from '../components/LeadFormModal';

const LeadFormContext = createContext();

export const useLeadForm = () => {
  const context = useContext(LeadFormContext);
  if (!context) {
    throw new Error('useLeadForm must be used within LeadFormProvider');
  }
  return context;
};

export const LeadFormProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openLeadForm = () => {
    setIsOpen(true);
  };

  const closeLeadForm = () => {
    setIsOpen(false);
  };

  return (
    <LeadFormContext.Provider value={{ openLeadForm, closeLeadForm }}>
      {children}
      <LeadFormModal isOpen={isOpen} onClose={closeLeadForm} />
    </LeadFormContext.Provider>
  );
};
